import React, { useMemo, useRef, useState } from 'react'
import './index.scss'
import { debounce } from 'lodash'
import clsx from 'clsx'
import Button from '@Components/Buttons/Button'

interface InputWithButtonProps {
    mainColor: boolean
    id: string
    type: 'submit' | 'sign-up'
    onChange: (value: string, id: string) => void
    value?: string
    errorMessage?: string
}

const InputWithButton = ({ mainColor, id, type, onChange, value, errorMessage }: InputWithButtonProps) => {
    const [inputValue, setInputValue] = useState(value || '')
    const [activeInputState, setActiveInputState] = useState(false)
    const inputValueRef = useRef(inputValue)
    inputValueRef.current = inputValue

    const onFocusInput = () => setActiveInputState(true)

    const onBlurInput = () => setActiveInputState(false)

    const onSave = useMemo(
        () =>
            debounce(() => {
                onChange(inputValueRef.current, id)
            }, 200),
        [onChange, id]
    )

    const handleChange = (event: any) => {
        setInputValue(event.target.value)
        onSave()
    }

    const classNames = clsx(
        'input-with-button-component',
        mainColor ? 'main-color-set' : 'second-color-set',
        type,
        activeInputState && 'focused',
        inputValue && 'filled',
        errorMessage && 'error'
    )

    return (
        <div className={classNames} data-testid={'input-with-button-component-' + id}>
            <div className="input-wrapper">
                <input
                    type="email"
                    id={id}
                    onBlur={onBlurInput}
                    onFocus={onFocusInput}
                    onChange={handleChange}
                    placeholder={!activeInputState ? 'Enter email...' : ''}
                />
                <Button mainColor={type === 'submit'} type="primary">
                    {type === 'submit' ? 'Submit' : 'Sign-up'}
                </Button>
            </div>
            {errorMessage ? <p className="error-text small">{errorMessage}</p> : null}
        </div>
    )
}

export default InputWithButton
